import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { SearchBarComponent } from '../../../../../shared/components/search-bar/search-bar.component';
import { CardBolsaComponent } from '../../../../../shared/components/card-bolsa/card-bolsa.component';
import { CadatrarBolsaComponent } from '../cadatrar-bolsa/cadatrar-bolsa.component';
import { ApiService } from '@core/providers/http/api.service';
import { Bolsa } from '../../api/models/bolsa.model';
import { BolsaService } from '../../api/services/bolsa.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {
  PaisService,
  BolseiroService,
  InstituicaoGestoraService,
  TipoBolsaService,
  InstituicaoEnsinoService,
} from '../../api/services';
import { City } from '../../api/models/city.model';
import { Bolseiro } from '../../api/models';

@Component({
  selector: 'app-lista-bolsas',
  standalone: true,
  imports: [
    CommonModule,
    SearchBarComponent,
    CardBolsaComponent,
    RouterModule,
    ToastModule,
  ],
  providers: [
    DialogService,
    ApiService,
    MessageService,
    BolsaService,
    PaisService,
    BolseiroService,
    InstituicaoGestoraService,
    TipoBolsaService,
    InstituicaoEnsinoService,
  ],
  templateUrl: './lista-bolsas.component.html',
  styleUrls: ['./lista-bolsas.component.scss'],
})
export class ListaBolsasComponent implements OnInit {
  dialogService = inject(DialogService);
  bolsaService = inject(BolsaService);
  messageService = inject(MessageService);
  paisService = inject(PaisService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  bolseiroService = inject(BolseiroService);
  instituicaoGestoraService = inject(InstituicaoGestoraService);
  tipoBolsaService = inject(TipoBolsaService);
  cities: City[] = [];
  router = inject(Router);
  paises: any[] = [];
  bolsas: Bolsa[] = [];
  isLoading: boolean = false;
  educationalInstitution: any[] = [];
  bolseirosList: Bolseiro[] = [];
  instituicaoGestoraList: any[] = [];
  tipoBolsaList: any[] = [];
  totalRecords: number = 0;
  page: number = 1;
  rows: number = 10;

  ngOnInit() {
    this.getAllBolsas();
    this.getAllPaises();
    this.getAllBolseiros();
    this.getAllInstituicaoGestora();
    this.getAllTipoBolsa();
    this.getAllInstituicoesEnsino();
    this.cities = [
      { name: 'New York', code: 'NY' },
      { name: 'Rome', code: 'RM' },
      { name: 'London', code: 'LDN' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' },
    ];
  }

  getAllPaises() {
    this.paisService.list().subscribe(
      (data) => {
        this.paises = data;
      },
      (error) => {
        console.error('Erro ao buscar países:', error);
      }
    );
  }

  getAllBolseiros(queryParams?: any) {
    this.isLoading = true; // Iniciar carregamento
    this.bolseiroService
      .list({ ...queryParams, page: this.page, rows: this.rows })
      .subscribe(
        (response: { data: Bolseiro[]; totalRecords: number }) => {
          this.bolseirosList = response.data;
          this.totalRecords = response.totalRecords;
          this.isLoading = false; // Parar carregamento
        },
        (error: any) => {
          console.error('Erro ao buscar bolseiros:', error);
          this.isLoading = false; // Parar carregamento
        }
      );
  }

  getAllInstituicaoGestora() {
    this.instituicaoGestoraService.list().subscribe(
      (data) => {
        this.instituicaoGestoraList = data;
      },
      (error) => {
        console.error('Erro ao buscar instituições gestoras:', error);
      }
    );
  }

  getAllTipoBolsa() {
    this.tipoBolsaService.list().subscribe(
      (data) => {
        this.tipoBolsaList = data;
      },
      (error) => {
        console.error('Erro ao buscar tipos de bolsa:', error);
      }
    );
  }

  onSecondBtnClick() {
    this.router.navigate(['/gestao-bolseiros/tipo-bolsa']);
  }

  onFormValueChange(formValue: any) {
    this.getAllBolsas(formValue);
  }

  getAllBolsas(queryParams?: any) {
    this.isLoading = true; // Iniciar carregamento
    this.bolsaService.list(queryParams).subscribe(
      (bolsas: Bolsa[]) => {
        this.bolsas = bolsas;
        this.isLoading = false; // Parar carregamento
      },
      (error: any) => {
        console.error('Erro ao buscar bolsas:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar bolsas.',
        });
        this.isLoading = false; // Parar carregamento
      }
    );
  }

  getAllInstituicoesEnsino() {
    this.instituicaoEnsinoService.list().subscribe((institutions) => {
      this.educationalInstitution = institutions.data;
    });
  }

  showDialog() {
    const ref = this.dialogService.open(CadatrarBolsaComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
      data: {
        bolseiros: this.bolseirosList,
        instituicaoGestora: this.instituicaoGestoraList,
        tipoBolsa: this.tipoBolsaList,
        educationalInstitution: this.educationalInstitution,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.isLoading = true; // Iniciar carregamento
        this.bolsaService.store(data).subscribe(
          (response: any) => {
            this.getAllBolsas();
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Bolsa criada com sucesso!',
            });

            this.isLoading = false; // Parar carregamento
          },
          (error: any) => {
            console.error('Erro ao criar bolsa:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao criar bolsa.',
            });
            this.isLoading = false; // Parar carregamento
          }
        );
      }
    });
  }
}
